<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-simple-table class="table-layout-module border-table">
          <template v-slot:default>
            <thead>
            <tr>
              <th v-for="(header, index) in headers" :key="'header'+index" class="px-4"
                :style="`text-align: ${header.align} !important;max-width: ${header.maxWidth} !important;min-width: ${header.minWidth} !important;`"
              >
                {{  header.text }}
              </th>
            </tr>
            </thead>
            <tbody v-if="data.length">
            <template v-for="(item, index) in data">
              <tr :class="index !== 0 ? 'father-row-01' : 'vh-edtech'" :key="`father-row${index}`"
                  style="cursor: pointer"
                  @click="index !== 0 ? toggle(item.uid) : ''">
                <th class="text-left" :style="index !== 0  ? 'font-size: 13px !important;' : 'font-size: 14px !important;'">
                  {{ item.name ? item.name : 'VH Edtech' }}
                </th>
                <td class="text-center font-weight-bold">{{ formatPrice(item.totalContact) }}</td>
                <td class="text-center font-weight-bold">{{ formatPrice(item.totalOrder) }}</td>
                <td class="text-center font-weight-bold">{{ formatPrice(Math.round(item.cr*100)) }}%</td>
                <td class="text-center font-weight-bold">
                  <span>{{formatPrice(item.arpu) || 0}}</span>
                </td>
                <td class="text-center font-weight-bold">
                  <span v-if="item.totalContact > 0">{{ ((item.totalSuccessOrder / item.totalContact)*100).toFixed(1) }}%</span>
                </td>
                <td class="text-center font-weight-bold">{{ formatPrice(Math.round(item.initTurnOver)) }}</td>
                <td class="text-center font-weight-bold">{{ formatPrice(Math.round(item.grossSale)) }}</td>
                <td class="text-center font-weight-bold">{{ formatPrice(Math.round(item.successTurnOver)) }}</td>
              </tr>
              <template  v-if="opened.includes(item.uid)">
                <template v-for="(item_child, key) in item.types">
                   <tr class="father-row" style="cursor: pointer"  @click="toggle(item_child.uid)">
                    <th class="text-left" style="font-weight: 400 !important;font-size: 12px !important;">
                      <span>{{ item_child.name }}</span>
                    </th>
                    <td class="text-center">{{ formatPrice(item_child.totalContact) }}</td>
                    <td class="text-center">{{ formatPrice(item_child.totalOrder) }}</td>
                    <td class="text-center">{{ formatPrice(Math.round(item_child.cr*100)) }}%</td>
                    <td class="text-center">
                      <span>{{formatPrice(item_child.arpu) || 0}}</span>
                    </td>
                    <td class="text-center">
                      <span v-if="item_child.totalContact > 0">{{ ((item_child.totalSuccessOrder / item_child.totalContact)*100).toFixed(1) }}%</span>
                    </td>
                    <td class="text-center">{{ formatPrice(Math.round(item_child.initTurnOver)) }}</td>
                    <td class="text-center">{{ formatPrice(Math.round(item_child.grossSale)) }}</td>
                    <td class="text-center">{{ formatPrice(Math.round(item_child.successTurnOver)) }}</td>
                  </tr>
                  <template v-if="!opened.includes(item_child.uid)">
                    <tr class="row-child" v-for="(schoolLevel, idx) in item_child.schoolLevels" :key="`schoolLevel${index}${idx}${key}`">
                      <th class="text-left" style="font-weight: 400 !important;font-size: 12px !important;">
                        <span>{{ schoolLevel.schoolLevelName }}</span>
                      </th>
                      <td class="text-center">{{ formatPrice(schoolLevel.totalContact) }}</td>
                      <td class="text-center">{{ formatPrice(schoolLevel.totalOrder) }}</td>
                      <td class="text-center">{{ formatPrice(Math.round(schoolLevel.cr*100)) }}%</td>
                      <td class="text-center"><span>{{formatPrice(schoolLevel.arpu) || 0}}</span></td>
                      <td class="text-center">
                        <span v-if="schoolLevel.totalContact > 0">{{ ((schoolLevel.totalSuccessOrder / schoolLevel.totalContact)*100).toFixed(1) }}%</span>
                      </td>
                      <td class="text-center">{{ formatPrice(Math.round(schoolLevel.initTurnOver)) }}</td>
                      <td class="text-center">{{ formatPrice(Math.round(schoolLevel.grossSale)) }}</td>
                      <td class="text-center">{{ formatPrice(Math.round(schoolLevel.successTurnOver)) }}</td>
                    </tr>
                  </template>
              </template>
              </template>
            </template>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="1000">
                <common-no-result />
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'TableModuleReport',
  props: {
    data: {
      type: Array,
      default: () => {[]}
    },
    total: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      opened: [],
      headers: [
        {text: 'Loại hình', align: 'left', sortable: false,minWidth:'180px', maxWidth: '200px'},
        {text: 'Contact (Lead)', align: 'center', sortable: false,minWidth:'150px', maxWidth: '200px'},
        {text: 'Đơn hàng', align: 'center', sortable: false,minWidth:'150px', maxWidth: '200px'},
        {text: 'CR', align: 'center', sortable: false,minWidth:'150px', maxWidth: '200px'},
        {text: 'APRU', align: 'center', sortable: false, minWidth: '200px'},
        {text: 'Tỷ lệ chốt thành công', align: 'center', sortable: false,minWidth:'150px', maxWidth: '200px'},
        {text: 'Doanh thu khởi tạo', align: 'center', sortable: false, minWidth: '200px'},
        {text: 'Gross sale', align: 'center', sortable: false, minWidth: '200px'},
        {text: 'Doanh thu thành công', align: 'center', sortable: false, minWidth: '200px'},
      ]
    }
  },
  methods: {
    toggle(idList) {
      const index = this.opened.indexOf(idList)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(idList)
      }
    },
  }
}
</script>

<style scoped>
/deep/ .v-data-table {
  border: 1px solid #D7D3F2 !important;
  border-radius: 10px;
}

/deep/ .v-data-table tbody:hover td, .v-data-table tbody:hover th {
  background: white;
}

/deep/ .v-data-table tbody td {
  font-size: 16px;
  font-weight: 400;
  border-bottom: thin solid #D7D3F2 !important;
  border-right: thin solid #D7D3F2 !important;
}

/deep/ .v-data-table tbody tr td:first-child {
  border-right: none;
}

/deep/ .v-data-table tbody tr {
  height: 60px !important;
}

/deep/ .v-data-table tbody tr th {
  border-right: thin solid #D7D3F2 !important;
  border-bottom: thin solid #D7D3F2 !important;
  /* color: #4C458D !important; */
  font-size: 16px !important;
  font-weight: 500 !important;
}

/deep/ .v-data-table thead tr th {
  border-right: thin solid #D7D3F2 !important;
  border-bottom: thin solid #D7D3F2 !important;
  color: hsl(0, 0%, 33.3%) !important;
  background: hsl(248.6, 36.8%, 96.3%) !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}

/deep/ .v-data-table tbody tr td:first-child {
  /*border-right: none !important;*/
}

/deep/ .v-data-table thead tr th:first-child {
  border-top-left-radius: 10px;
}

/deep/ .v-data-table thead tr th:last-child {
  border-top-right-radius: 10px;
}

/deep/ .v-data-table tbody tr:last-child th {
  border-bottom-left-radius: 10px;
}

/deep/ .v-data-table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

/deep/ .row-child th {
  padding-left: 30px !important;
  font-size: 12px !important;
}
/deep/ .row-child td {
  font-size: 12px !important;
}


/deep/ .father-row th {
  background: #EEEEEE  !important;
  font-size: 12px !important;
}

/deep/ .father-row td {
  background: #EEEEEE  !important;
  font-weight: 400 !important;
  font-size: 12px !important;
}

/deep/ .father-row-01 th {
  background: #B5B5B5 !important;
  font-weight: 600 !important;
}

/deep/ .father-row-01 td {
  background: #B5B5B5 !important;
  font-weight: 600 !important;
  font-size: 13px !important;
}
/deep/ .vh-edtech th, /deep/ .vh-edtech td {
  font-weight: 600 !important;
  color: #00801C !important;
  font-size: 14px !important;
}


</style>